export const getReferralsMenuItems = ({ isReferralPage, isRnDomain, isMcDomain }) => {
  const menuGroup = []

  menuGroup.push({
    img: 'influencers',
    title: 'Client Referral',
    href: `/referral`,
    active: isReferralPage,
    visible: !isRnDomain && !isMcDomain,
  })

  return menuGroup
}
